/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerpagedescription2Inputs */

const en_organizerpagedescription2 = /** @type {(inputs: Organizerpagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your page on Pulsify: people follow you and get your new events in their feed.`)
};

const de_organizerpagedescription2 = /** @type {(inputs: Organizerpagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Seite auf Pulsify: Leute folgen dir und bekommen deine neuen Events in den Feed.`)
};

/**
* | output |
* | --- |
* | "Your page on Pulsify: people follow you and get your new events in their feed." |
*
* @param {Organizerpagedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerpagedescription2 = /** @type {((inputs?: Organizerpagedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerpagedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerpagedescription2(inputs)
	return de_organizerpagedescription2(inputs)
});
export { organizerpagedescription2 as "organizerPageDescription" }